import React, { useState } from 'react'
import TuberLogo from "../../assets/u_logo.webp"
import Post1 from "../../assets/posts/1.jpg"
import Post2 from "../../assets/posts/2.jpg"
import Post3 from "../../assets/posts/3.jpg"
import Post4 from "../../assets/posts/4.jpg"
import Post5 from "../../assets/posts/5.jpg"
import Post6 from "../../assets/posts/6.jpg"
import Post7 from "../../assets/posts/7.jpg"
import Post8 from "../../assets/posts/8.jpg"
import Post9 from "../../assets/posts/9.jpg"
import Post10 from "../../assets/posts/10.jpg"
import { FaInstagram } from "react-icons/fa6";

const posts = [
    { image: Post1, link: "https://www.instagram.com/tuberdelivery/p/C9i4JALSi1g/" },
    { image: Post2, link: "https://www.instagram.com/tuberdelivery/p/C8TUlAAy9Yt/" },
    { image: Post3, link: "https://www.instagram.com/tuberdelivery/reel/C6-Xw3pv_t4/" },
    { image: Post4, link: "https://www.instagram.com/tuberdelivery/reel/C64xrd0yGe6/" },
    { image: Post5, link: "https://www.instagram.com/tuberdelivery/p/C6sNMwzP0Px/" },
    { image: Post6, link: "https://www.instagram.com/tuberdelivery/p/C6KOZHgBZsx/" },
    { image: Post7, link: "https://www.instagram.com/tuberdelivery/p/C6IRyYMPWFU/" },
    { image: Post8, link: "https://www.instagram.com/tuberdelivery/p/C5SceUhNC8X/" },
    { image: Post9, link: "https://www.instagram.com/tuberdelivery/p/C5P2ig-M1fh/" },
    { image: Post10, link: "https://www.instagram.com/tuberdelivery/p/C5Fj7xXsOvw/" },
];

const SocialMediaPosts = () => {
    const DEFAULT_VISIBLE = 8;
    const [visiblePosts, setVisiblePosts] = useState(DEFAULT_VISIBLE);

    const handleLoadMoreOrLess = () => {
        if (visiblePosts >= posts.length) {
            setVisiblePosts(DEFAULT_VISIBLE);
        } else {
            setVisiblePosts(prev => Math.min(prev + 4, posts.length));
        }
    };

    const handleFollowInstagram = () => {
        window.open("https://www.instagram.com/tuberdelivery", "_blank");
    };

    const isShowingAll = visiblePosts >= posts.length;

    return (
        <section className='px-4 py-12 md:py-28'>
            <div className='max-w-7xl mx-auto w-full'>
                <div className='flex items-center gap-5'>
                    <div className='w-14 md:w-20 h-14 md:h-20 rounded-full overflow-hidden bg-black/75 border border-gray-200'>
                        <img src={TuberLogo} alt="Tuber Logo" loading='lazy' className='w-full h-full object-cover' />
                    </div>

                    <div className='flex flex-col gap-1 flex-1'>
                        <h2 className='text-headings text-base md:text-lg font-semibold'>Tuberdelivery</h2>
                        <p className='text-light_black text-sm md:text-lg'>Fast . Reliable . Commercial Deliveries in 2 hours.</p>
                    </div>
                </div>

                <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-6 py-6'>
                    {posts.slice(0, visiblePosts).map((post, index) => (
                        <div key={index} className='relative overflow-hidden'>
                            <a href={post.link} target="_blank" rel="noopener noreferrer" className='popup-gallery w-full h-full'>
                                <img src={post.image} alt={`Post ${index + 1}`} />
                                <div className='eye-wrapper absolute inset-0 flex justify-center items-center'>
                                    <FaInstagram size={40} />
                                </div>
                            </a>
                        </div>
                    ))}
                </div>

                <div className='flex justify-center items-center gap-2'>
                    <button
                        onClick={handleLoadMoreOrLess}
                        className='py-2 px-2 md:px-4 bg-primary rounded text-white uppercase text-sm font-medium w-fit  hover:opacity-85 transition-opacity duration-300'
                    >
                        {isShowingAll ? "Load less" : "Load more"}
                    </button>

                    <button
                        onClick={handleFollowInstagram}
                        className='py-2 px-2 md:px-4 bg-primary rounded text-white uppercase flex items-center gap-1 text-sm font-medium w-fit hover:opacity-85 transition-opacity duration-300'
                    >
                        <FaInstagram size={16} />
                        Follow on Instagram
                    </button>
                </div>
            </div>
        </section>
    );
};

export default SocialMediaPosts;
